import styled, { css } from "styled-components"

export const Overlay = styled.div`
  position: fixed;
  top: 270px;
  left: 0;
  background: rgba(0,0,0,0.4);
  width: 100%;
  height: 100%;
  z-index: 6;
`

export const SearchWrapper = styled.form`
  justify-content: center;
  position: relative;
  z-index: 20;
  flex: 1 1 auto;
  position: relative;
  max-width: 830px;
  height: 48px;
  white-space: nowrap;
  align-items: center;
  display: flex;

  ${
    ({ mobileLayout }) => {
      if (mobileLayout) {
        return css`
          flex-direction: column;
          margin: 80px auto;
        `
      }
    }
  }

  ${
    ({ peopleOnly }) => {
      if (peopleOnly) {
        return css`
          width: 100%;
          display: block;
          max-width: none;
        `
      }
    }
  }
`;

export const TriggerFiltersWrapper = styled.div`
  margin-right: 15px;
  flex: 0 0 115px;

  @media screen and (max-width: 550px) {
    display: none;
  }

  ${
    ({ mobileLayout }) => {
      if (mobileLayout ) {
        return css`
          @media screen and (max-width: 550px) {
            display: flex;
          }
          flex: 0 0 45px;
          align-items: center;
          margin: 0px;
          padding-left: 10px;
          width: 100%;
          background: #fff;
          border: 1px solid #ccc;
          border-radius: 0px;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          border-top: none; // already on the popover filters

          & > button {
            border: none;
          }
        `
      }
    }
  }
`

export const TriggerFiltersButton = styled.button`
  color: #858585;
  font-size: 16px;
  font-weight: normal;
  display: flex;
  width: 100%;
  height: 32px;
  align-items: center;
  justify-content: center;
  column-gap: 7px;
  border-right: 1px solid #ccc;
  border-radius: 0px;

  ${
    ({ mobileLayout }) => {
      if (mobileLayout ) {
        return css`
          justify-content: flex-start;
        `
      }
    }
  }  
`

export const InnerSearchWrapper = styled.div`
  padding: 5px 10px;
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-start;
  column-gap: 10px;
  align-items: center;
  height: 100%;
  max-width: 720px;
  white-space: normal;
  background: #fff;
  border: 1px solid #ccc;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;

  @media screen and (max-width: 900px) {
    max-width: 100%;
}
  ${
    ({ mobileLayout }) => {
      if (mobileLayout ) {
        return css`
        @media screen and (max-width: 900px) {
          border-radius: 0px;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
        }
          width: 100%;
          border: 1px solid #ccc;
        `
      }
    }
  }

${
    ({ peopleOnly }) => {
      if (peopleOnly ) {
        return css`
          width: 100%;
          max-width: none;
          border: none;
          border-bottom: 1px solid #ccc;
          border-bottom-left-radius: 0px;
        `
      }
    }
  }
`;

export const LoadingIndicator = styled.div`
  flex: 0 0 30px;
`

export const SearchButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  column-gap: 10px;
  background-color: #125F3F;
  height: 100%;
  flex: 0 0 110px;
  border-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  @media screen and (max-width: 550px) {
    display: none;
  }

  ${
    ({ mobileLayout }) => {
      if (mobileLayout ) {
        return css`
          @media screen and (max-width: 550px) {
            display: flex;
          }
          margin-top: 10px;
          justify-content: center;
          align-items: center;
          color: #fff;
          background-color: #125F3F;
          flex: auto;
          padding: 20px;
          width: 100%;
          border-radius: 5px;
        `
      }
    }
  }
`

export const StyledBigSearcher = styled.div`
    flex: 1 1 auto;    

    & .react-autosuggest__input {
        background: transparent;
        outline: none;
        width: 100%;
        height: 35px;
        border-width: 0px;
    }

    & .react-autosuggest__suggestions-container {
      width: 100%;
      background: #fff;
      max-height: 400px;
      overflow-y: auto;
      overflow-x: hidden;
      position: absolute;
      top: ${({ mobileLayout }) => mobileLayout ? "-6px" : "48px"};
      left: 0;
      box-shadow: 0px 10px 20px 0px #aaa;
      z-index: 10;
    }

    & .react-autosuggest__section-container {
      border-top: 1px solid #eee;
      padding: 10px 0;
    }

    & .react-autosuggest__section-container--first {
      border-top: 0px;
    }

    & .react-autosuggest__section-title {
      color: #858585;
      padding: 0 10px;
    }

    & .react-autosuggest__suggestion {
      margin-top: 10px;
      padding: 2px 10px;
    }

    & .react-autosuggest__suggestion--highlighted {
      cursor: pointer;
      background: #e6e6e6;
    }
`

export const StyledMobileSearchBar = styled.div`
    display: flex;
    flex-direction: column;

  & .react-autosuggest__input {
    background: transparent;
    outline: none;
    width: 100%;
    height: 35px;
    border-width: 0px;
  }

  & .react-autosuggest__suggestions-container {
    width: 100%;
    background: #fff;
    max-height: 400px;
    overflow-y: auto;
    position: absolute;
    top: 42px;
    left: 0;
    box-shadow: 0px 10px 20px 0px #aaa;
    z-index: 10;
  }

  & .react-autosuggest__section-container {
    border-top: 1px solid #eee;
    padding: 10px 0;
  }

  & .react-autosuggest__section-container--first {
    border-top: 0px;
  }

  & .react-autosuggest__section-title {
    color: #858585;
    padding: 0 10px;
  }

  & .react-autosuggest__suggestion {
    margin-top: 10px;
    padding: 2px 10px;
  }

  & .react-autosuggest__suggestion--highlighted {
    cursor: pointer;
    background: #e6e6e6;
  }
`